import React from 'react';
import './_styles.scss';

function EdgeAssignmentField({ label, id = '', value = '', onClick = null }) {
  const isUnassigned = !id || id === 'N/A';

  return (
    <div className="staticField">
      <div className="label">
        {label}
        <div className="value assignment-field">
          {isUnassigned ? (
            <span className="unassigned-value" />
          ) : onClick ? (
            <span className="assignment-link" onClick={onClick} role="button" tabIndex={0}>
              {value}
            </span>
          ) : (
            <span>{value}</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default EdgeAssignmentField;
